// ************************************************************************
// Note: dpbutils on client is different than dpbutils on server. Server 
// interacts with mongodb directly, where client side dpbutils interacts with API's    
// ************************************************************************
import axios from 'axios';
import getAppConfigParm  from '../config/AppConfig';

//************************************************************************ */
// Configuration
//************************************************************************ */

// trace functions
let trace = true;
let compName = 'dpbutils-clientside'
import { prtMsg, prtStart, prtEnd, prtVar, prtObjVar  } from './prt';

// Obtain filename and initialize appname for logging purpose

const appname  = 'pic';

const loginfo_enabled    = true; 
const logerror_enabled   = true;

/* ********************************************************************* */
/* New Logging and logging related functions                             */
/* ********************************************************************* */

//  used to pluck just the filename from global variables
const pluckFilename = (filename, directory) =>  {
  return filename.substring(directory.length+1, filename.length);
}
const filename = pluckFilename(__filename, __dirname);

const loginfo = (fn, info) => {
  if (loginfo_enabled) {
    var logformat = "YYYY-MM-DD hh:mm:ss SSSS";
    console.info(`INFO: ${new Date()} - (fn:${fn}) ${info} `);
  }
}

const logerror = (fn, errortext, errorstack) =>  {
  if (logerror_enabled) {
    // var logformat = "YYYY-MM-DD hh:mm:ss SSSS";
    let rightNow  = new Date();
    if (!errorstack) errorstack = "";
    console.error(`ERROR: ${rightNow} (fn:${fn}) - ${errortext} ${errorstack} `);
  }
}

/* saves log information to database */
function saveErrorRecord (
      appname = "no appname",
      filename = "no filename", 
      functionName = "no function name", 
      userid = 'no userid', 
      generatedErrorText = "no generated text", 
      actualError 
    )
{
  /* define variable for stringified version of actual error */
  let systemErrorText = "";
  /* Declare stringify friendly replacer function */
  function jsonErrorReplacer(key, value) {
    if (value instanceof Error) {
      return {
        // Pull all enumerable properties, supporting properties on custom Errors
        ...value,
        // Explicitly pull Error's non-enumerable properties
        name: value.name,
        message: value.message,
        stack: value.stack,
      }
    }
    return value
  }
  
  /* If actualError is a javascript Error Object stringify using jsonErrorReplace, If object other 
     than Error, try stringify, otherwise assume its a string and leave as is */ 
  if (actualError instanceof Error) {
    systemErrorText = JSON.stringify(actualError, jsonErrorReplacer);
  } else 
    if (typeof actualError === 'object') {
      systemErrorText = JSON.stringify(actualError);
  } else {
    systemErrorText = actualError;
  }

  trace && prtStart(compName, 'saveErrorRecord');

  /* instantiate error record */
  var payload = {
    key: getAppConfigParm('logkey'),
    appname,
    filename,
    functionName,
    userid,
    generatedErrorText,
    systemErrorText
  };

  // trace && prtObjVar('payload', payload);

  // Construct url for api call and set up header
  let url    = getAppConfigParm("picUrl") + '/error/record'; 
  let header = getAppConfigParm("axiosConfig");

  // Make api call save error record in database
  axios.post(url, payload, header)
      .then(function (response) {
      trace && prtMsg('Successfully saved errorRecord');
      console.log(response);
  }).catch ((error) => {  /* TBD - this error should be logged to database */
      trace && prtMsg('Error encounted tyring to log errorRecord');
      trace && prtVar('error', error);
  });

  trace && prtEnd(compName, 'saveErrorRecord');
}

/* ********************************************************************* */
/* Date related functions                                                */
/* ********************************************************************* */

// function currentDateTimestamp(dateString) {
//   // return moment.utc().utcOffset(-05:00);
//   if (dateString) {
//     return moment(dateString).format('YYYY-MM-DDTHH:mm:ss.SSS');
//   }
//   return moment().format('YYYY-MM-DDTHH:mm:ss.SSS'); //.utcOffset('-05:00').format();
// }

/* ********************************************************************** */
/* Helper function to convert an emitted message to a standard error type */
/* ********************************************************************** */
function getErrorType(err) {
  var errorType = "UncaughtException";

  if (err.message.includes('NoRecordFound')) {
     errorType =  'NoRecordFound';
     return errorType;
  }

  if (err.message.includes('InvalidPassword')) {
    errorType =  'InvalidPassword';
    return errorType;
  }

  if (err.message.includes('AuthFailure')) {
     errorType =  'AuthFailure';
     return errorType;
  }

  if (err.message.includes('E11000')) {
    return 'DuplicateRecord';
  }

  if (err.message.includes('users validation failed')) {
     if (err.errors.email.message.includes('not a valid email')) {
         errorType =  'EmailValidationError';
     }
     return errorType;
  }

  if (err.message.includes('EmailValidationError')) {
     errorType =  'EmailValidationError';
     return errorType;
  }

  if (err.message.includes('InvalidAuthToken')) {
     errorType =  'InvalidAuthToken';
     return errorType;
  }

  if (err.message.includes('MongoNetworkError')) {
     errorType =  'MongoNetworkError';
     return errorType;
  }

  return errorType;
};

function convertDateToTicks(dateString) {
  epochTicks = 621355968000000000;
  ticksPerMillesecond = 10000;
  date = new Date(dateString);
  dateInTicks =  epochTicks + (date.getTime() * ticksPerMillesecond);
  return dateInTicks;
};

/* ********************************************************************* */
/* Private helper functions
/* ********************************************************************* */

const isObject = (testVar) => {
   return typeof testVar === 'object' && typeof testVar !== 'function';
}

const isArray = (testVar) => {
   return testVar instanceof Array;
}

/* ********************************************************************* */
/* Error Messages: takes an error message name and message extension       */
/* ********************************************************************* */
// Pass in name value pairs related to type error
// const getErrMsg = function getErrMsg(msgName, msgExt )  {
//     var errorTable = {
//         DuplicateRecord: "DuplicateRecord: Record already exist in database for " + msgExt,
//         MissingParms:    "MissingParms: Missing parameters: " + msgExt,
//         NotSingleton :   "NotSingleton: Did not get back a Singleton result as expected: " + msgExt,
//         NoRecordsFound:  "NoRecordsFound: Lookup returned no results " + msgExt,
//         SystemException:   "SystemException: system error or uncaught exception "  + msgExt,
//     }
//     return errorTable[msgName];
// }

// function DuplicateRecordError(message) {
//     this.name = "DuplicateRecordError";
//     this.message = message;
// }
// DuplicateRecordError.protype = new Error();

module.exports = {
  pluckFilename,
  loginfo,
  logerror,
  getErrorType,
  saveErrorRecord,
  convertDateToTicks
}



// WEBPACK FOOTER //
// ./src/utils/dpbutils.js